module.exports = __webpack_public_path__ + "img/ic_avatar_profile.c5a137c9.svg";